




export enum ErrorCode {
    


    PermissionDeniedError = 20003,

    


    InvalidAccessToken = 20101,

    


    AccessTokenExpired = 20104,

    


    TooManyRequests = 20429,

    


    InternalServerError = 20500,

    


    ServiceUnavailable = 20503,

    


    AuthorizationError = 45003,

    


    ValidationError = 45004,

    
    


    FailedToRemoveParticipant = 48100,

    


    FailedToCompleteReservation = 48101,

    


    FailedToEndTask = 48102,

    


    FailedToRejectReservation = 48103,

    


    FailedToWrapUpReservation = 48104,

    


    FailedToSetTaskAttributes = 48105,
    

    


    FailedToSetCurrentWorkerActivityDueToPendingReservations = 48200,

    


    FailedToSetCurrentWorkerActivity = 48201,

    


    FailedToSetCurrentWorkerAttributes = 48202,

    
    


    FailedToSetWorkerActivityBySupervisor = 48300,

    


    ActivityChangeRejectedPendingReservations = 48301,

    


    FailedToSetWorkerAttributesBySupervisor = 48302,

    

    


    CallerIdUndefined = 48400,

    


    FailedToAddExternalVoiceParticipant = 48401,

    


    FailedToEndConference = 48402,

    


    FailedToHoldExternalParticipant = 48403,

    


    FailedToHoldWorkerParticipant = 48404,

    


    FailedToHoldVoiceParticipant = 48405,

    


    FailedSelfKick = 48406,

    


    FailedToKickVoiceParticipant = 48407,

    


    FailedToUnholdExternalParticipant = 48408,

    


    FailedToUnholdWorkerParticipant = 48409,

    


    FailedToUnholdVoiceParticipant = 48410,

    


    WorkerCannotUnholdReservation = 48411,

    


    WorkerCannotHoldReservation = 48412,

    


    InvalidParticipantSid = 48413,

    


    VoiceDeviceNotInitialized = 48414,

    


    UnknownVoiceEventName = 48415,

    


    FailedToAddVoiceEventListener = 48416,

    


    FailedToGetCallByTask = 48417,

    


    FailedToGetConferenceData = 48418,

    


    SupervisorAlreadyMonitoringCall = 48419,

    


    FailedToMonitorCall = 48420,

    


    FromNumberRequired = 48421,

    


    TaskQueueSidRequired = 48422,

    


    WorkflowSidRequired = 48423,

    


    WorkerOfflineOutboundCallCancelled = 48424,

    


    OutboundCallingDisabled = 48425,

    


    InboundCallPendingOutboundCancelled = 48426,

    


    InboundCallAcceptedOutboundCancelled = 48427,

    


    NoAudioInputDeviceAvailable = 48428,

    


    IncomingCallTimeout = 48429,

    


    FailedToCreateTask = 48430,

    


    FailedToDisconnectCall = 48431,

    


    VoiceReservationNotLiveCall = 48432,

    


    NoConferenceSidFoundInTaskAttributes = 48433,

    


    NoActiveRecordingToPause = 48434,

    


    FailedToPauseRecording = 48435,

    


    NoActiveRecordingToResume = 48436,

    


    FailedToResumeRecording = 48437,

    


    CallInstanceUndefined = 48438,

    


    FailedToHoldCall = 48439,

    


    FailedToUnholdCall = 48440,

    


    NoActiveTransferForVoiceTask = 48441,

    


    FailedToCancelVoiceTaskTransfer = 48442,

    


    VoiceTaskTransferAlreadyInitiated = 48443,

    


    WorkerCannotTransferVoiceTaskFromDifferentWorker = 48444,

    


    FailedToStartVoiceTaskTransfer = 48445,

    


    FailedToCreateVoiceTaskReservation = 48446,

    


    VoiceReservationNotFound = 48447,

    

    


    FailedToPeekConversation = 48500,

    


    FailedToPauseConversation = 48501,

    


    FailedToResumeConversation = 48502,

    


    FailedToLeaveConversation = 48503,

    


    FailedToStartConversationTransfer = 48504,

    


    ConversationTransferForbidden = 48505,

    


    ConversationTransferRetrievingForbidden = 48506,

    


    FailedToRetrieveConversationTransfer = 48507,

    


    FailedToRetrieveConversationsUser = 48508,

    


    FailedToSendMessage = 48509,

    


    FailedToSendTypingIndicator = 48510,

    


    FailedToRetrieveMessages = 48511,

    


    WorkerOfflineEmailTaskCancelled = 48512,

    


    FailedToCreateOutboundEmailTask = 48513,

    


    FailedToAddEmailParticipant = 48514,

    


    TaskNotEmailTask = 48515,

    


    FailedToRemoveEmailParticipant = 48516,

    


    FailedToRetrievePausedConversations = 48517,

    


    NoConversationSidFoundForTask = 48518,

    


    FailedToGetReservationAfterConversationResuming = 48519,

    


    WorkerParticipantNotFoundForTask = 48520,

    


    MessageContentMissing = 48521,

    


    FailedToRetrieveOutboundEmailSettings = 48522,

    


    OutboundEmailWorkflowSidUndefined = 48523,

    


    OutboundEmailQueueSidUndefined = 48524,

    


    OutboundEmailFromParameterUndefined = 48525,

    


    FailedToCreateOutboundEmailTaskReservation = 48526,

    


    FailedToAddConversationEventListener = 48527,

    


    ConversationsSdkConnectionInvalidState = 48528,

    
    


    WorkerNotInitialized = 48900,

    


    TaskReservationNotFound = 48901,

    


    MissingRequiredParameter = 48902,

    


    ConversationNotAvailable = 48903,

    


    ParticipantNotFound = 48904,

    


    FailedToUpdateTokenOnSession = 48905,

    


    FailedToInitializeConversationsSDK = 48906,

    


    MissingTaskInteractionSid = 48907,

    


    MissingChannelSid = 48908,

    


    InvalidResponseFromPublicConfig = 48909,

    


    FailedToAcceptReservation = 48910,

    


    FailedToRetrieveConversation = 48911,

    


    FailedToGetFlexInstanceSid = 48912,

    


    FailedToRetrieveTaskParticipants = 48913,

    


    ActiveChannelNotFound = 48914,

    


    TaskNotVoiceTask = 48915,

    


    TaskrouterOfflineActivitySidNotConfigured = 48916,

    


    FailedToCreateConference = 48917,

    


    UnexpectedError = 48918,

    


    UnknownError = 48919,

    


    AccessDeniedError = 48920,

    


    BadGateway = 48921,

    


    GatewayTimeout = 48922,

    


    NotFound = 48923,

    


    NetworkError = 48924,

    


    InvalidState = 48925,

    


    InvalidParams = 48926,

    


    DownstreamServiceError = 48927,

    


    FailedToFetchAccountConfiguration = 48928,

    


    FailedToFetchFeatures = 48929,
    


    FailedToFetchPublicConfiguration = 48930,

    


    BadRequest = 70002,

    


    BadSsoSettings = 70251
}

export type PublicErrorInfoMap = Record<ErrorCode, string>;

export const publicErrorDetails: PublicErrorInfoMap = {
    [ErrorCode.PermissionDeniedError]: "You lack permission to the resource and method you requested",
    [ErrorCode.InvalidAccessToken]: "Invalid Access Token",
    [ErrorCode.AccessTokenExpired]: "Access Token expired or expiration date invalid",
    [ErrorCode.TooManyRequests]: "TooManyRequests: Twilsock rate limit exceeded",
    [ErrorCode.InternalServerError]: "InternalServerError",
    [ErrorCode.ServiceUnavailable]: "Service Unavailable",
    [ErrorCode.AuthorizationError]: "Attempt to access resource where access is not allowed for given credentials",
    [ErrorCode.ValidationError]: "Validation error: request body validation fails",
    [ErrorCode.AccessDeniedError]: "User is not authorized to perform the requested operation",
    [ErrorCode.BadGateway]: "Bad Gateway",
    [ErrorCode.GatewayTimeout]: "Gateway timed out",
    [ErrorCode.NotFound]: "Resource not found",
    [ErrorCode.NetworkError]: "NetworkError: Not able to reach the server",
    [ErrorCode.InvalidState]: "Invalid state",
    [ErrorCode.InvalidParams]: "Invalid parameter(s)",
    [ErrorCode.DownstreamServiceError]: "Downstream error",
    [ErrorCode.BadRequest]: "BadRequest: The data in the request is unparsable",
    [ErrorCode.BadSsoSettings]:
        "The Request tries to authenticate through SSO. The request is well-formed, but the configured settings for the SSO is not valid.",
    [ErrorCode.WorkerNotInitialized]: "Worker is not initialized",
    [ErrorCode.TaskReservationNotFound]: "Task reservation not found or has invalid status",
    [ErrorCode.MissingRequiredParameter]: "Missing required parameter",
    [ErrorCode.ParticipantNotFound]: "Participant not found",
    [ErrorCode.FailedToRetrieveConversation]: "Failed to retrieve conversation due to internal error",
    [ErrorCode.FailedToPauseConversation]: "Failed to pause conversation due to internal error",
    [ErrorCode.FailedToResumeConversation]: "Failed to resume conversation due to internal error",
    [ErrorCode.FailedToLeaveConversation]: "Failed to leave conversation due to internal error",
    [ErrorCode.FailedToStartConversationTransfer]: "Failed to start conversation transfer due to internal error",
    [ErrorCode.ConversationTransferForbidden]:
        "Failed to start conversation transfer due to internal error. Conversation transfer might not be enabled in configuration",
    [ErrorCode.ConversationTransferRetrievingForbidden]:
        "Failed to retrieve conversation transfer due to internal error. Conversation transfer might not be enabled in configuration",
    [ErrorCode.FailedToRetrieveConversationTransfer]: "Failed to retrieve conversation transfer due to internal error",
    [ErrorCode.ConversationNotAvailable]: "Conversation is not available",
    [ErrorCode.FailedToSendMessage]: "Failed to send message due to internal error",
    [ErrorCode.FailedToRetrieveMessages]: "Failed to retrieve messages due to internal error",
    [ErrorCode.WorkerOfflineEmailTaskCancelled]: "Worker is offline, outbound email task cancelled",
    [ErrorCode.FailedToCreateOutboundEmailTask]: "Failed to create outbound email task due to internal error",
    [ErrorCode.FailedToAddEmailParticipant]: "Failed to add email participant due to internal error",
    [ErrorCode.TaskNotEmailTask]: "Task is not an email task",
    [ErrorCode.FailedToRemoveEmailParticipant]: "Failed to remove email participant due to internal error",
    [ErrorCode.FailedToRetrievePausedConversations]: "Failed to retrieve paused conversations due to internal error",
    [ErrorCode.FailedToInitializeConversationsSDK]: "Failed to initialize Conversations SDK due to internal error",
    [ErrorCode.FailedToPeekConversation]: "Failed to peek conversation due to internal error",
    [ErrorCode.NoConversationSidFoundForTask]: "No conversationSid found for task",
    [ErrorCode.MissingTaskInteractionSid]: "Missing interactionSid for task",
    [ErrorCode.MissingChannelSid]: "Missing channelSid for task",
    [ErrorCode.FailedToGetReservationAfterConversationResuming]:
        "Failed to get reservation after conversation resuming due to internal error",
    [ErrorCode.FailedToAcceptReservation]: "Failed to accept reservation due to internal error",
    [ErrorCode.FailedToGetFlexInstanceSid]: "Failed to get Flex instance SID from account configuration",
    [ErrorCode.FailedToRetrieveTaskParticipants]: "Failed to retrieve task participants due to internal error",
    [ErrorCode.WorkerParticipantNotFoundForTask]: "Worker participant not found for provided task",
    [ErrorCode.FailedToSendTypingIndicator]: "Failed to send typing indicator due to internal error",
    [ErrorCode.TaskrouterOfflineActivitySidNotConfigured]: "Taskrouter offline activity SID is not configured",
    [ErrorCode.FailedToRetrieveOutboundEmailSettings]:
        "Failed to retrieve outbound email settings due to internal error",
    [ErrorCode.OutboundEmailWorkflowSidUndefined]:
        "The outbound email workflow SID is neither configured in the Twilio Console nor provided in the options",
    [ErrorCode.OutboundEmailQueueSidUndefined]:
        "The outbound email queue SID is neither configured in the Twilio Console nor provided in the options",
    [ErrorCode.OutboundEmailFromParameterUndefined]:
        "The outbound email 'from' parameter is neither configured in the Twilio Console nor provided in the options",
    [ErrorCode.FailedToCreateOutboundEmailTaskReservation]:
        "Failed to create reservation for outbound email task due to internal error",
    [ErrorCode.FailedToCreateVoiceTaskReservation]: "Failed to create reservation for outbound call task",
    [ErrorCode.FailedToRetrieveConversationsUser]:
        "Failed to retrieve conversations user by identity due to internal error",
    [ErrorCode.MessageContentMissing]: "Cannot send an empty message",
    [ErrorCode.CallerIdUndefined]:
        "Caller ID is undefined. Provide it as a parameter or configure it in account configuration",
    [ErrorCode.FailedToAddExternalVoiceParticipant]: "Failed to add external voice participant due to internal error",
    [ErrorCode.FailedToEndConference]: "Failed to end conference due to internal error",
    [ErrorCode.FailedToHoldExternalParticipant]: "Failed to hold external participant due to internal error",
    [ErrorCode.FailedToHoldWorkerParticipant]: "Failed to hold worker participant due to internal error",
    [ErrorCode.FailedToHoldVoiceParticipant]: "Failed to hold participant due to internal error",
    [ErrorCode.FailedSelfKick]: "Worker cannot kick themselves from task",
    [ErrorCode.FailedToKickVoiceParticipant]: "Failed to kick participant due to internal error",
    [ErrorCode.FailedToUnholdExternalParticipant]: "Failed to unhold external participant due to internal error",
    [ErrorCode.FailedToUnholdWorkerParticipant]: "Failed to unhold worker participant due to internal error",
    [ErrorCode.FailedToUnholdVoiceParticipant]: "Failed to unhold participant due to internal error",
    [ErrorCode.WorkerCannotUnholdReservation]:
        "The worker cannot unhold reservation because it must be a live call assigned to them",
    [ErrorCode.WorkerCannotHoldReservation]:
        "The worker cannot hold reservation because it must be a live call assigned to them",
    [ErrorCode.InvalidParticipantSid]: "Invalid Participant SID",
    [ErrorCode.TaskNotVoiceTask]: "Task is not a voice task",
    [ErrorCode.FailedToCreateConference]: "Failed to create a conference due to internal error",
    [ErrorCode.UnexpectedError]: "Unexpected error",
    [ErrorCode.UnknownError]: "Unknown error",
    [ErrorCode.VoiceDeviceNotInitialized]: "Voice device not initialized",
    [ErrorCode.UnknownVoiceEventName]: "Unknown voice event name",
    [ErrorCode.FailedToAddVoiceEventListener]: "Failed to add voice event listener due to internal error",
    [ErrorCode.FailedToGetCallByTask]: "Failed to get call by task. The call might be active on different device",
    [ErrorCode.FailedToGetConferenceData]: "Failed to get conference data from task",
    [ErrorCode.SupervisorAlreadyMonitoringCall]: "Supervisor is already monitoring the call for this task",
    [ErrorCode.FailedToMonitorCall]: "Failed to monitor call due to internal error",
    [ErrorCode.FromNumberRequired]:
        "Parameter 'fromNumber' is required for outbound call. Provide it as a parameter or configure it in account configuration",
    [ErrorCode.TaskQueueSidRequired]:
        "Task queue SID is required for outbound call. Provide it as a parameter or configure it in account configuration",
    [ErrorCode.WorkflowSidRequired]:
        "Workflow SID is required for outbound call. Provide it as a parameter or configure it in account configuration",
    [ErrorCode.WorkerOfflineOutboundCallCancelled]: "Worker is offline, outbound call cancelled",
    [ErrorCode.OutboundCallingDisabled]: "Outbound calling is disabled in Flex account configuration",
    [ErrorCode.InboundCallPendingOutboundCancelled]:
        "Another voice task is already in pending status, outbound call cancelled",
    [ErrorCode.InboundCallAcceptedOutboundCancelled]:
        "Another voice task is already in accepted status, outbound call cancelled",
    [ErrorCode.NoAudioInputDeviceAvailable]: "No audio input device available, outbound call cancelled",
    [ErrorCode.IncomingCallTimeout]: "Timeout occurred because no incoming call event was received within 30 seconds",
    [ErrorCode.FailedToCreateTask]: "Failed to create task due to internal error",
    [ErrorCode.NoActiveTransferForVoiceTask]: "No active transfer found for voice task",
    [ErrorCode.FailedToCancelVoiceTaskTransfer]: "Failed to cancel voice task transfer due to internal error",
    [ErrorCode.FailedToRemoveParticipant]: "Failed to remove participant during task completion due to internal error",
    [ErrorCode.FailedToCompleteReservation]:
        "Failed to complete reservation during task completion due to internal error",
    [ErrorCode.FailedToEndTask]: "Failed to end task due to internal error",
    [ErrorCode.FailedToRejectReservation]: "Failed to reject reservation due to internal error",
    [ErrorCode.VoiceTaskTransferAlreadyInitiated]: "Voice task transfer already initiated",
    [ErrorCode.WorkerCannotTransferVoiceTaskFromDifferentWorker]:
        "Worker cannot transfer voice task assigned to different worker",
    [ErrorCode.FailedToStartVoiceTaskTransfer]: "Failed to start voice task transfer due to internal error",
    [ErrorCode.FailedToSetWorkerActivityBySupervisor]:
        "Failed to set worker activity by the supervisor due to internal error",
    [ErrorCode.ActivityChangeRejectedPendingReservations]:
        "The activity change initiated by the supervisor for the worker was rejected due to internal error because the worker has pending reservations",
    [ErrorCode.FailedToSetWorkerAttributesBySupervisor]: "Failed to set worker attributes due to internal error",
    [ErrorCode.FailedToWrapUpReservation]: "Failed to wrap-up reservation due to internal error",
    [ErrorCode.FailedToDisconnectCall]: "Failed to disconnect call due to internal error",
    [ErrorCode.VoiceReservationNotLiveCall]: "Voice reservation is not a live call",
    [ErrorCode.NoConferenceSidFoundInTaskAttributes]: "No conference SID found in task attributes",
    [ErrorCode.NoActiveRecordingToPause]:
        "Failed to pause the recording due to internal error. There is no active recording to pause",
    [ErrorCode.NoActiveRecordingToResume]:
        "Failed to resume the recording due to internal error. There is no active recording to resume",
    [ErrorCode.VoiceReservationNotFound]: "Voice reservation not found for worker",
    [ErrorCode.CallInstanceUndefined]: "Call instance is undefined due to call might be active on a different device",
    [ErrorCode.FailedToAddConversationEventListener]: "Failed to add conversation event listener due to internal error",
    [ErrorCode.ActiveChannelNotFound]: "Active channel not found for task",
    [ErrorCode.FailedToUpdateTokenOnSession]: "Failed to update token on session due to internal error",
    [ErrorCode.InvalidResponseFromPublicConfig]: "Invalid response from public configuration endpoint",
    [ErrorCode.FailedToHoldCall]: "Failed to hold call due to internal error",
    [ErrorCode.FailedToUnholdCall]: "Failed to unhold call due to internal error",
    [ErrorCode.FailedToPauseRecording]: "Failed to pause the recording due to internal error",
    [ErrorCode.FailedToResumeRecording]: "Failed to resume the recording due to internal error",
    [ErrorCode.FailedToSetCurrentWorkerActivityDueToPendingReservations]:
        "Cannot set activity due to internal error: worker has pending reservations",
    [ErrorCode.FailedToSetCurrentWorkerActivity]: "Failed to set activity due to internal error",
    [ErrorCode.FailedToSetCurrentWorkerAttributes]: "Failed to set worker attributes due to internal error",
    [ErrorCode.FailedToSetTaskAttributes]: "Failed to set task attributes due to internal error",
    [ErrorCode.ConversationsSdkConnectionInvalidState]: "Conversations SDK connection changed to invalid state",
    [ErrorCode.FailedToFetchAccountConfiguration]: "Failed to fetch account configuration due to internal error",
    [ErrorCode.FailedToFetchFeatures]: "Failed to fetch features due to internal error",
    [ErrorCode.FailedToFetchPublicConfiguration]: "Failed to fetch public configuration due to internal error"
};


export const debuggerErrorCodes = [
    ErrorCode.PermissionDeniedError,
    ErrorCode.InvalidAccessToken,
    ErrorCode.AccessTokenExpired,
    ErrorCode.TooManyRequests,
    ErrorCode.AuthorizationError,
    ErrorCode.ValidationError,
    ErrorCode.BadRequest,
    ErrorCode.BadSsoSettings,
    ErrorCode.InternalServerError
];
